import React, { useState, useEffect } from "react";
import API_BASE from "../config/api";
import Swal from "sweetalert2";

// ---- TOASTER ALERT FUNCTION ----
const showToast = (message, icon) => {
    Swal.fire({
        toast: true,
        position: "top-end",
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 2000,
        customClass: {
            popup:
                icon === "success"
                    ? "my-toast my-toast-success"
                    : icon === "error"
                        ? "my-toast my-toast-error"
                        : "my-toast my-toast-warning",
        },
    });
};

export default function WebHome() {

    const user = JSON.parse(localStorage.getItem("user"));
    const listinguid = localStorage.getItem("listinguid");

    const [formData, setFormData] = useState({
        sitename: "",
        slogan: ""
    });

    const [loading, setLoading] = useState(true);

    // ===========================
    // LOAD EXISTING DATA
    // ===========================
    useEffect(() => {
        fetch(`${API_BASE}/api/get_webhome.php?personaluid=${user.personaluid}&listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.data) {
                    setFormData({
                        sitename: data.data.name ?? "",
                        slogan: data.data.slogan ?? ""
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                showToast("Failed to load data", "error");
            });
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // ===========================
    // SAVE DATA WITH TOASTER
    // ===========================
    const handleSubmit = (e) => {
        e.preventDefault();

        const fd = new FormData();
        fd.append("personaluid", user.personaluid);
        fd.append("fullname", user.fullname);
        fd.append("listinguid", listinguid);
        fd.append("sitename", formData.sitename);
        fd.append("slogan", formData.slogan);

        fetch(`${API_BASE}/api/save_webhome.php`, {
            method: "POST",
            body: fd
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    showToast(data.message, "success");
                } else {
                    showToast(data.message, "error");
                }
            })
            .catch(() => {
                showToast("Something went wrong", "error");
            });
    };

    if (loading) return <div className="p-4 text-secondary">Loading...</div>;

    return (
        <div className="container-fluid px-4 py-3">

            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >
                <h5 className="fw-bold text-dark mb-1">Website – Home</h5>
                <p className="text-secondary mb-0">Update your website contents.</p>
            </div>

            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <form autoComplete="off" onSubmit={handleSubmit}>

                        <div className="row">
                            <div className="col-md-5 mb-3">
                                <label className="form-label fw-semibold">
                                    Website Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="sitename"
                                    className="form-control form-control-sm"
                                    value={formData.sitename}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-7 mb-3">
                                <label className="form-label fw-semibold">
                                    Slogan <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="slogan"
                                    className="form-control form-control-sm"
                                    value={formData.slogan}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="text-end">
                            <button type="submit" className="btn btn-primary px-4 mt-2">
                                <i className="bi bi-cloud-upload-fill me-1"></i>
                                Update
                            </button>
                        </div>

                    </form>

                </div>
            </div>

        </div>
    );
}
